var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('b-spinner',{staticClass:"ml-auto mr-auto mb-3",staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"success","type":"grow","label":"Spinning"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }